module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/165-belgium-fc762681555c38dcbcfd723ff8f6dfd8.svg";